const NAMESPACE = 'TRIP_DATA';

const SET_TRIP = `${NAMESPACE}/SET_TRIP`;
const SET_TRIP_DETAILS = `${NAMESPACE}/SET_TRIP_DETAILS`;
const SET_TRIP_ITINERARY = `${NAMESPACE}/SET_TRIP_ITINERARY`;
const SET_TRIP_INFORMATION = `${NAMESPACE}/SET_TRIP_INFORMATION`;
const SET_TRIP_NOT_FOUND = `${NAMESPACE}/SET_TRIP_NOT_FOUND`;
const SET_TRIPS = `${NAMESPACE}/SET_TRIPS`;
const UPDATE_TRIP = `${NAMESPACE}/UPDATE_TRIP`;
const REMOVE_TRIP = `${NAMESPACE}/REMOVE_TRIP`;

export {
    REMOVE_TRIP,
    SET_TRIP,
    SET_TRIPS,
    SET_TRIP_DETAILS,
    SET_TRIP_INFORMATION,
    SET_TRIP_ITINERARY,
    SET_TRIP_NOT_FOUND,
    UPDATE_TRIP,
};

export default NAMESPACE;
